<template>
  <div>
    <!-- 轮播图 -->
<!--    <van-swipe :autoplay="3000" class="swipe-container">-->
<!--      <van-swipe-item v-for="(item, index) in bannerList" :key="index">-->
<!--        <img :src="item.image" :alt="item.title" />-->
<!--      </van-swipe-item>-->
<!--    </van-swipe>-->

    <!-- 产品分类宫格 -->
    <div class="category-section">
      <h2 class="section-title">产品分类</h2>
      <van-grid :column-num="2" :gutter="10">
        <van-grid-item
          v-for="item in categories"
          :key="item.id"
          @click="navigateToCategory(item.id)"
        >
          <div class="grid-item-content">
<!--            <van-image-->
<!--              :src="item.imgUrl"-->
<!--              width="100%"-->
<!--              height="140"-->
<!--              fit="cover"-->
<!--              radius="8"-->
<!--            />-->
            <span class="grid-item-title">{{ item.name }}</span>
            <span class="grid-item-desc">{{ getCategoryDescription(item.name) }}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>

    <!-- 关于我们 -->
    <div class="about-section">
      <h2 class="section-title">关于我们</h2>
      <p class="about-text">湘城贵人真朱砂是一家以发掘朱砂价值为根本传承朱砂工艺，弘扬朱砂文化，科普朱砂知识的名牌企业。湘城贵人真朱砂创始人经营朱砂已有20余年。是正宗的湖南湘西朱砂，有着自己的朱砂矿和朱砂饰品加工工厂，有三家朱砂工艺品展厅和朱砂文化科普馆，现有3000多个加盟商，五十余家加盟店。有成熟的朱砂制作加工工艺，其产品是经过三十多道湘西传统古法工艺制作而成的朱砂饰品。现有一百多个品种，三千多款朱砂类产品。主要经营朱砂系列所有产品。有朱砂原矿，原石，朱砂压模工艺品，朱砂粉等。</p>
    </div>

    <!-- 备案信息 -->
    <div class="beian-section">
      <p><a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">豫ICP备2025116718号</a></p>
      <p><img src="@/assets/head.png" width="20"/><a href="https://beian.mps.gov.cn/#/query/webSearch?code=41132402411900" rel="noreferrer" target="_blank">豫公网安备41132402411900号</a></p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import request from '@/utils/request';

const router = useRouter();

// 轮播图数据
// const bannerList = ref([
//   {
//     image: 'http://ss472xqcz.hn-bkt.clouddn.com/swiper/ChMkK2N1qpmIInw6AChvhgPOQdUAAJvcQKi4ToAKG-e762.jpg',
//     title: '朱砂艺术'
//   },
//   {
//     image: 'http://ss472xqcz.hn-bkt.clouddn.com/swiper/ChMkK2N1qqeIc_txACHXexPNBJ0AAJvcgO5FzcAIdeT255.jpg',
//     title: '精品展示'
//   },
//   {
//     image: 'http://ss472xqcz.hn-bkt.clouddn.com/swiper/ChMkLGN1qqGIedOSABY-4ZRYgKYAAJvcgGuO3oAFj75120.jpg',
//     title: '工艺展示'
//   }
// ]);

// 产品分类数据
const categories = ref([]);

// 获取分类数据
const fetchCategories = async () => {
  try {
    const response = await request.get('/api/v1/cinnabarOpen/selectAllMajorCategories');
    if (response.code === '00000' && response.data) {
      categories.value = response.data;
    }
  } catch (error) {
    console.error('获取分类数据失败:', error);
  }
};

// 获取分类描述
const getCategoryDescription = (name) => {
  const descriptions = {
    '帝王砂': '臻选优质朱砂，打造尊贵精品',
    '紫金砂': '珍贵紫金，品质非凡',
    '晶体砂': '天然晶体，品质卓越'
  };
  return descriptions[name] || '优质朱砂，精工制作';
};


// 页面导航
const navigateToCategory = (categoryId) => {
  router.push({
    name: 'productList',
    params: { categoryId }
  });
};

onMounted(() => {
  fetchCategories();
});
</script>

<style scoped>
.swipe-container {
  margin-bottom: 20px;
}

.swipe-container img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.category-section {
  padding: 20px;
  background-color: #fff;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #c62f2f;
}

.grid-item-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
}

.grid-item-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-top: 8px;
}

.grid-item-desc {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  text-align: center;
}

.about-section {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}

.about-text {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
}

.beian-section {
  text-align: center;
  padding: 15px 0;
  background-color: #fff;
  margin-top: 20px;
}

:deep(.van-grid-item__content) {
  padding: 8px;
  background-color: #f8f8f8;
  border-radius: 12px;
}

:deep(.van-grid-item__content:active) {
  background-color: #f0f0f0;
}
</style>
